import { render, staticRenderFns } from "./srOrganizationCombobox.vue?vue&type=template&id=dfa56386&scoped=true"
import script from "./srOrganizationCombobox.vue?vue&type=script&lang=js"
export * from "./srOrganizationCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa56386",
  null
  
)

export default component.exports